<template>
	<div class="opts_wrap" v-loading="loading">
		
	</div>
</template>

<script>
import Vue from 'vue';
import { mapActions,mapState,mapMutations } from "vuex";
export default {
	name: "trackDetail",
	props: {
		isLoading: {
			type: Boolean,
			default: false
		},
		show: {
			type: Boolean,
			default: false,
			
		},
		order_id: {
			type: Number,
			default: 0
		},
	},
	data() {
		return {
			loading: false
		};
	},
	
	created(){
	},
	mounted() {
		
		this.init()
	},
	
	computed:{
		...mapState({
			
		}),
	},
	watch:{
		show(val) {
			if(val){
				this.init()
			}
		}
	},
	
	methods: {
		...mapActions({
			getSupplierOrderTrackDetail:"ucenter/getSupplierOrderTrackDetail",
		}),
		init(){
			this.getSupplierOrderTrackDetail({data:{order_id:this.order_id},success:(res)=>{
					console.log(res)
			}})
		},
		
	},

}
</script>

<style scoped>
	
</style>
